import { reactive } from 'vue';

export const criarUsuario = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdusuario: 0,
        nmusuario: '',
        cpf: '',
        celular: '',
        fone: '',
        email: '',
        login: '',
        senha: '',
        dtsenha: '',
        ckativo: 'S',
        ckadmin: 'N',
        idlogin: 0,
        idusuario: 0
    });
};